(ns ductile.ui.workflow-generator
  (:require #_["array-move" :as array-move]
   #_["react-easy-sort" :as react-easy-sort]
   [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]))

(defn select
  "A select element with default styles."
  [& content]
  (let [options? (map? (first content))]
    (into [:select.select-box
           (if options? (first content) {})]
          (if options? (rest content) content))))

(def entry-services
  [{:service/code "Eingangshandling"}
   {:service/code "Eingangsmeldung"}
   {:service/code "Fahrzeugzustand" :field :single-select :label "Fahrzeugzustand"}
   {:service/code "Ausstattung erfassen" :field :multi-select :label "Ausstattung"}
   {:service/code "Batterieprüfung"}
   {:service/code "Kilometerstand erfassen"}
   {:service/code "ZP8 Datum erfassen"}])

(def storage-services
  [{:service/code "Batterieprüfung"}
   {:service/code "Wochenpflege"}
   {:service/code "Reifendruck prüfen"}
   {:service/code "Batteriepflege"}
   {:service/code "Freibremsen"}])

(def after-storage-services
  [{:service/code "PDI"}
   {:service/code "Folie entfernen"}
   {:service/code "Finish"}
   {:service/code "Fahrzeugwäsche"}
   {:service/code "Tanken" :field :numeric :label "Menge" :unit "L"}])

(def exit-services
  [{:service/code "Bahnbeladung"}
   {:service/code "Bereitstellung Selbstabholer"}])

(defn assign-workflow-name-view []
  [:<>
   [ui/with-label
    [:span.font-bold.text-lg.mb-2 "Auftragsname"]
    [:input {:class "w-full text-lg border rounded-lg px-4 py-2 "
             :on-input #(deframe/route-assoc-in! [::state :workflow-name] (.. % -target -value))
             :value @(deframe/!route-get-in [::workflow :name])}]]
   (when-not @(deframe/!route-get-in [::workflow :name])
     [ui/button
      {:variant :primary
       :size 4
       :on-click #(deframe/route-assoc-in! [::workflow :name] @(deframe/!route-get-in [::state :workflow-name]))
       :class "mt-3"}
      [:span.text-xl "Neuen Auftrag anlegen"]])])

(defn assign-workflow-data-source []
  [:<>
   [:div.text-lg.font-bold.mb-2 "Datenquelle auswählen"]
   [:div.flex.items-center.gap-2
    [ui/button
     {:variant (if (= :edi @(deframe/!route-get-in [::workflow :source])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :source] :edi)} "DFÜ"]
    [ui/button
     {:variant (if (= :edi-manual @(deframe/!route-get-in [::workflow :source])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :source] :edi-manual)} "DFÜ und manuelle Erfassung"]
    [ui/button
     {:variant (if (= :manual @(deframe/!route-get-in [::workflow :source])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :source] :manual)} "Manuelle Erfassung"]]])

(defn assign-entry-services-applicable []
  [:<>
   [:div.text-lg.font-bold.mb-2 "Eingangsdienstleistungen?"]
   [:div.flex.items-center.gap-2
    [ui/button
     {:variant (if (true? @(deframe/!route-get-in [::workflow :entry-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :entry-services-applicable?] true)} "Ja"]
    [ui/button
     {:variant (if (false? @(deframe/!route-get-in [::workflow :entry-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :entry-services-applicable?] false)} "Nein"]]])

(defn assign-entry-services []
  (let [!assigned-services (deframe/!route-get-in [::workflow :entry-services])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Eingangsdienstleistungen zuweisen"]
     (into [:div.flex.flex-col.gap-2]
           (map-indexed
            (fn [i {:as service :keys [service/code]}]
              [:div.px-3.py-2.bg-slate-50.border.rounded-md
               [:div.flex.items-center.gap-2.mb-1.text-lg
                [:input {:id (str "entry-service-" i)
                         :type :checkbox
                         :checked (get @!assigned-services code)
                         :on-change #(if (get @!assigned-services code)
                                       (deframe/route-dissoc-in! [::workflow :entry-service code])
                                       (deframe/route-assoc-in! [::workflow :entry-service code] (assoc service :group :entry-service)))}]
                [:label.text-lg {:for (str "entry-service-" i)} code]]
               [:div.flex.items-center.gap-4 {:class "ml-[23px]"}
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio
                          :checked true}]
                 [:label.text-sm {:for ""} "automatisch"]]
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio}]
                 [:label.text-sm {:for ""} "manuell"]]]]))
           entry-services)]))

(defn assign-storage-services-applicable []
  [:<>
   [:div.text-lg.font-bold.mb-2 "Lagerfahrzeug?"]
   [:div.flex.items-center.gap-2
    [ui/button
     {:variant (if (true? @(deframe/!route-get-in [::workflow :storage-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :storage-services-applicable?] true)} "Ja"]
    [ui/button
     {:variant (if (false? @(deframe/!route-get-in [::workflow :storage-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :storage-services-applicable?] false)} "Nein"]]])

(defn assign-storage-services []
  (let [!assigned-services (deframe/!route-get-in [::workflow :storage-services])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Lagerdienstleistungen zuweisen"]
     (into [:div.flex.flex-col.gap-2]
           (map-indexed
            (fn [i {:as service :keys [service/code]}]
              [:div.px-3.py-2.bg-slate-50.border.rounded-md
               [:div.flex.items-center.gap-2.mb-1.text-lg
                [:input {:id (str "storage-service-" i)
                         :type :checkbox
                         :checked (get @!assigned-services code)
                         :on-change #(if (get @!assigned-services code)
                                       (deframe/route-dissoc-in! [::workflow :storage-service code])
                                       (deframe/route-assoc-in! [::workflow :storage-service code] (assoc service :group :storage-service)))}]
                [:label.text-lg {:for (str "storage-service-" i)} code]]
               [:div {:class "ml-[23px]"}
                [:div.flex.items-center.gap-4
                 [:div.flex.items-center.gap-1
                  [:input {:id ""
                           :type :radio}]
                  [:label.text-sm {:for ""} "automatisch"]]
                 [:div.flex.items-center.gap-1
                  [:input {:id ""
                           :type :radio}]
                  [:label.text-sm {:for ""} "manuell"]]]
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :checkbox}]
                 [:label.text-sm "nach"]
                 [ui/input {:placeholder "0" :class "w-[50px]" :size 4}]
                 [:label.text-sm "Tagen alle "]
                 [ui/input {:placeholder "0" :class "w-[50px]" :size 4}]
                 [:label.text-sm "Tage"]]]])
            storage-services))]))

(defn assign-after-storage-services-applicable []
  [:<>
   [:div.text-lg.font-bold.mb-2 "Dienstleistungen nach Lager?"]
   [:div.flex.items-center.gap-2
    [ui/button
     {:variant (if (true? @(deframe/!route-get-in [::workflow :after-storage-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :after-storage-services-applicable?] true)} "Ja"]
    [ui/button
     {:variant (if (false? @(deframe/!route-get-in [::workflow :after-storage-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :after-storage-services-applicable?] false)} "Nein"]]])

(defn assign-after-storage-services []
  (let [!assigned-services (deframe/!route-get-in [::workflow :after-storage-services])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Dienstleistungen nach Lager zuweisen"]
     (into [:div.flex.flex-col.gap-2]
           (map-indexed
            (fn [i {:as service :keys [service/code]}]
              [:div.px-3.py-2.bg-slate-50.border.rounded-md
               [:div.flex.items-center.gap-2.mb-1.text-lg
                [:input {:id (str "entry-service-" i)
                         :type :checkbox
                         :checked (get @!assigned-services code)
                         :on-change #(if (get @!assigned-services code)
                                       (deframe/route-dissoc-in! [::workflow :after-storage-service code])
                                       (deframe/route-assoc-in! [::workflow :after-storage-service code] (assoc service :group :after-storage-service)))}]
                [:label.text-lg {:for (str "entry-service-" i)} code]]
               [:div.flex.items-center.gap-4 {:class "ml-[23px]"}
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio
                          :checked true}]
                 [:label.text-sm {:for ""} "automatisch"]]
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio}]
                 [:label.text-sm {:for ""} "manuell"]]]
               (when (:field service)
                 [:div.flex.items-center.gap-2.text-sm.mt-1
                  {:class "ml-[23px]"}
                  [:label (:label service)]
                  [ui/input {:style {:width 100} :size 4}]
                  [:label (:unit service)]])]))
           after-storage-services)]))

(defn assign-entry-transport-modes []
  (let [!assigned-modes (deframe/!route-get-in [::workflow :entry-transport-modes])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Fahrzeugeingang"]
     (into [:div]
           (map-indexed
            (fn [i {:as transport-mode :keys [mode label]}]
              [:div.flex.items-center.gap-2.mb-1.text-lg
               [:input {:id (str "entry-transport-mode-" i)
                        :type :checkbox
                        :checked (get @!assigned-modes mode)
                        :on-change #(if (get @!assigned-modes mode)
                                      (deframe/route-dissoc-in! [::workflow :entry-transport-modes mode])
                                      (deframe/route-assoc-in! [::workflow :entry-transport-modes mode] transport-mode))}]
               [:label {:for (str "entry-transport-mode-" i)} label]]))
           [{:mode :truck :label "LKW"}
            {:mode :train :label "Bahn"}])]))

(defn assign-exit-transport-modes []
  (let [!assigned-modes (deframe/!route-get-in [::workflow :exit-transport-modes])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Fahrzeugausgang"]
     (into [:div]
           (map-indexed
            (fn [i {:as transport-mode :keys [mode label]}]
              [:div.flex.items-center.gap-2.mb-1.text-lg
               [:input {:id (str "transport-mode-" i)
                        :type :checkbox
                        :checked (get @!assigned-modes mode)
                        :on-change #(if (get @!assigned-modes mode)
                                      (deframe/route-dissoc-in! [::workflow :exit-transport-modes mode])
                                      (deframe/route-assoc-in! [::workflow :exit-transport-modes mode] transport-mode))}]
               [:label {:for (str "transport-mode-" i)} label]]))
           [{:mode :own-wheels :label "Selbstabholer"}
            {:mode :truck :label "LKW"}
            {:mode :train :label "Bahn"}])]))

(defn assign-exit-services-applicable []
  [:<>
   [:div.text-lg.font-bold.mb-2 "Ausgangsdienstleistungen?"]
   [:div.flex.items-center.gap-2
    [ui/button
     {:variant (if (true? @(deframe/!route-get-in [::workflow :exit-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :exit-services-applicable?] true)} "Ja"]
    [ui/button
     {:variant (if (false? @(deframe/!route-get-in [::workflow :exit-services-applicable?])) :primary :white)
      :size 4
      :on-click #(deframe/route-assoc-in! [::workflow :exit-services-applicable?] false)} "Nein"]]])

(defn assign-exit-services []
  (let [!assigned-services (deframe/!route-get-in [::workflow :exit-services])]
    [:<>
     [:div.text-lg.font-bold.mb-2 "Ausgangsdienstleistungen zuweisen"]
     (into [:div.flex.flex-col.gap-2]
           (map-indexed
            (fn [i {:as service :keys [service/code]}]
              [:div.px-3.py-2.bg-slate-50.border.rounded-md
               [:div.flex.items-center.gap-2.mb-1.text-lg
                [:input {:id (str "entry-service-" i)
                         :type :checkbox
                         :checked (get @!assigned-services code)
                         :on-change #(if (get @!assigned-services code)
                                       (deframe/route-dissoc-in! [::workflow :exit-service code])
                                       (deframe/route-assoc-in! [::workflow :exit-service code] (assoc service :group :exit-service)))}]
                [:label.text-lg {:for (str "entry-service-" i)} code]]
               [:div.flex.items-center.gap-4 {:class "ml-[23px]"}
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio
                          :checked true}]
                 [:label.text-sm {:for ""} "automatisch"]]
                [:div.flex.items-center.gap-1
                 [:input {:id ""
                          :type :radio}]
                 [:label.text-sm {:for ""} "manuell"]]]]))
           exit-services)]))

(defn save-flow! []
  (let [{:as workflow :keys [id]} @(deframe/!route-get ::workflow)
        workflows (or @(deframe/!route-get ::workflows) {})]
    (deframe/tx! [[:op/assoc-in [:current-route/transient ::workflow :edit-mode] :pricing]
                  [:op/assoc-in [:current-route/transient ::workflows id] workflow]])))

(defn save-prices! []
  (let [{:as workflow :keys [id]} @(deframe/!route-get ::workflow)
        workflows (or @(deframe/!route-get ::workflows) {})]
    (deframe/tx! [[:op/dissoc-in [:current-route/transient ::workflow]]
                  [:op/assoc-in [:current-route/transient ::workflows id] workflow]])))

(defn edit-workflow! [id]
  (deframe/tx! [[:op/assoc-in [:current-route/transient ::workflow] (get @(deframe/!route-get ::workflows) id)]
                [:op/assoc-in [:current-route/transient ::workflow :editing?] true]
                [:op/assoc-in [:current-route/transient ::workflow :edit-mode] :flow]
                [:op/dissoc-in [:current-route/transient ::select-edit-workflow]]]))

(defn flow []
  [:<>
   [:div.p-5
    [assign-workflow-name-view]]
   (when @(deframe/!route-get-in [::workflow :name])
     [:div.p-5.border-t
      [assign-workflow-data-source]])
   (when @(deframe/!route-get-in [::workflow :source])
     [:div.p-5.border-t
      [assign-entry-transport-modes]])
   (when (exists? @(deframe/!route-get-in [::workflow :entry-transport-modes]))
     [:div.p-5.border-t
      [assign-entry-services-applicable]])
   (when (true? @(deframe/!route-get-in [::workflow :entry-services-applicable?]))
     [:div.p-5.border-t
      [assign-entry-services]])
   (when (exists? @(deframe/!route-get-in [::workflow :entry-services-applicable?]))
     [:div.p-5.border-t
      [assign-storage-services-applicable]])
   (when (true? @(deframe/!route-get-in [::workflow :storage-services-applicable?]))
     [:div.p-5.border-t
      [assign-storage-services]])
   (when (exists? @(deframe/!route-get-in [::workflow :storage-services-applicable?]))
     [:div.p-5.border-t
      [assign-after-storage-services-applicable]])
   (when (true? @(deframe/!route-get-in [::workflow :after-storage-services-applicable?]))
     [:div.p-5.border-t
      [assign-after-storage-services]])
   (when (exists? @(deframe/!route-get-in [::workflow :storage-services-applicable?]))
     [:div.p-5.border-t
      [assign-exit-transport-modes]])
   (when (exists? @(deframe/!route-get-in [::workflow :exit-transport-modes]))
     [:div.p-5.border-t
      [assign-exit-services-applicable]])
   (when (true? @(deframe/!route-get-in [::workflow :exit-services-applicable?]))
     [:div.p-5.border-t
      [assign-exit-services]])
   (when (exists? @(deframe/!route-get-in [::workflow :exit-services-applicable?]))
     [:<>
      (when @(deframe/!route-get-in [::workflow :editing?])
        [:div.p-5.border-t
         [:div.font-bold.text-lg.mb-2 "Änderungen nur gültig für"]
         [:div.flex.items-center.gap-2.text-lg
          [:input {:id "changes-apply-to-new"
                   :type :radio
                   :name :changes-apply-to
                   :checked (= :new  @(deframe/!route-get-in [::workflow :changes-apply-to]))
                   :on-change #(deframe/route-assoc-in! [::workflow :changes-apply-to] :new)}]
          [:label {:for "changes-apply-to-new"} "Neue Fahrzeugeingänge"]]
         [:div.flex.items-center.gap-2.text-lg
          [:input {:id "changes-apply-to-new-and-storage"
                   :type :radio
                   :name :changes-apply-to
                   :checked (= :new-and-storage  @(deframe/!route-get-in [::workflow :changes-apply-to]))
                   :on-change #(deframe/route-assoc-in! [::workflow :changes-apply-to] :new-and-storage)}]
          [:label {:for "changes-apply-to-new-and-storage"} "Neue Fahrzeugeingänge und Bestandsfahrzeuge"]]])
      [:div.p-5.border-t.flex.items-center.gap-3
       (if @(deframe/!route-get-in [::workflow :valid?])
         [ui/button {:variant :primary
                     :size 4
                     :on-click #(save-flow!)}
          [:span.text-xl "Speichern & freigeben"]]
         [ui/button {:variant :primary
                     :size 4
                     :on-click #(deframe/route-assoc-in! [::workflow :valid?] true)}
          [:span.text-xl "Prüfen"]])]])])

(defn new-default-price []
  {:price 0
   :currency "EUR"
   :vat 0.19
   :payee "contract-customer"})

(defn service-prices [{:as service :keys [service/code group]}]
  (let [priced? @(deframe/!route-get-in [::workflow group code :priced?])
        prices @(deframe/!route-get-in [::workflow group code :prices])]
    [:div.px-5.py-5.border-b.last:border-b-0
     [:div.flex.justify-between.items-center
      [:div.font-bold.text-lg code]
      [:div.flex.items-center.gap-1
       [:label "mit Berechnung"]
       [:input {:type :checkbox
                :checked priced?
                :on-change (fn []
                             (if priced?
                               (deframe/route-assoc-in! [::workflow group code :priced?] false)
                               (deframe/tx!
                                (vec (concat
                                      [[:op/assoc-in [:current-route/transient ::workflow group code :priced?] true]]
                                      (when (nil? prices)
                                        [[:op/assoc-in
                                          [:current-route/transient ::workflow group code :prices]
                                          [(new-default-price)]]]))))))}]]]
     (when priced?
       [:div.flex.flex-col.gap-2.pt-3
        (into [:<>]
              (map-indexed
               (fn [i {:keys [price currency vat payee predicates]}]
                 [:div.rounded-md.bg-slate-50.pt-1.px-3.pb-3.border
                  [:div.flex.items-center.gap-4.mt-2
                   [:div
                    [:div.font-bold.text-sm "Preis"]
                    [:div.flex.items-center.gap-1
                     [ui/input {:placeholder "0,00" :style {:width 100} :size 4}]
                     [select
                      {:class "py-2" :value currency}
                      [:option {:value "eur"} "EUR"]
                      [:option {:value "chf"} "CHF"]
                      [:option {:value "czk"} "CZK"]]]]
                   [:div
                    [:div.font-bold.text-sm "MwSt"]
                    [select
                     {:class "py-2" :value (str vat)}
                     [:option {:value "0.19"} "19%"]
                     [:option {:value "0.2"} "20%"]
                     [:option {:value "0.16"} "16%"]]]
                   [:div
                    [:div.font-bold.text-sm "zahlender Kunde"]
                    [select
                     {:class "py-2" :value payee}
                     [:option {:value "contract-customer"} "Auftragskunde"]
                     [:option {:value "delivery-customer"} "Lieferkunde"]
                     [:option {:value "custom"} "Individuell"]]]]
                  (when predicates
                    [:div.flex.mt-4.items-center.gap-4
                     [:div
                      [:div.font-bold.text-sm "Hersteller"]
                      [select
                       {:class "py-2" :value (:make predicates)}
                       [:option {:value nil} "egal"]
                       [:option {:value "bmw"} "BMW"]
                       [:option {:value "vw"} "VW"]
                       [:option {:value "audi"} "Audi"]]]
                     [:div
                      [:div.font-bold.text-sm "Fahrzeuggruppe"]
                      [select
                       {:class "py-2" :value (:make predicates)}
                       [:option {:value nil} "egal"]
                       [:option {:value "bmw-i3"} "BMW i3"]
                       [:option {:value "vw-id3"} "VW id3"]
                       [:option {:value "audi-a3"} "Audi A3"]]]
                     [:div
                      [:div.font-bold.text-sm "Motorentyp"]
                      [select
                       {:class "py-2" :value (:make predicates)}
                       [:option {:value nil} "egal"]
                       [:option {:value "internal-combustion"} "Verbrenner"]
                       [:option {:value "hybrid"} "Hybrid"]
                       [:option {:value "electric"} "Elektrisch"]]]
                     [:div.mt-4.ml-3
                      [:button.text-indigo-600.flex.gap-1.items-center.px-2.py-1.rounded-md.hover:bg-indigo-100
                       {:on-click #(deframe/route-assoc-in! [::workflow group code :prices] (vec (concat (take i prices)
                                                                                                         (drop (inc i) prices))))}
                       [ui/icon {:size 20} :trash]
                       [:span "Preis entfernen"]]]])]))
              prices)
        [:div.flex.justify-end
         [:button.text-indigo-600.flex.gap-1.items-center.bg-indigo-50.px-2.py-1.rounded-md.hover:bg-indigo-100
          {:on-click #(deframe/route-assoc-in! [::workflow group code :prices (count prices)]
                                               (assoc (new-default-price) :predicates {}))}
          [ui/icon {:size 20} :plus]
          [:span "zusätzlichen Preis hinzufügen"]]]])]))

(comment
  (let [prices @(deframe/!route-get-in [::workflow :entry-service "Eingangshandling" :prices])
        i 1]
    (vec (concat (take i prices)
                 (drop (inc i) prices)))))

(defn pricing []
  (let [{:keys [entry-service storage-service after-storage-service exit-service]} @(deframe/!route-get ::workflow)]
    [:<>
     (into [:div]
           (map
            (fn [service]
              [service-prices service]))
           (map second (concat entry-service storage-service after-storage-service exit-service)))
     [:div.p-5.border-t.flex.items-center.gap-3
      [ui/button {:variant :primary
                  :size 4
                  :on-click #(save-prices!)}
       [:span.text-xl "Speichern & freigeben"]]]]))

(defn workflow-menu []
  [:div.bg-white.shadow-xl.border.rounded-lg.flex.flex-col.mb-8
   {:class "min-w-[650px]"}
   [:div.p-5.bg-slate-100.rounded-t-lg.border-b
    [:div.text-center.text-xl.font-bold "Auftragseinsteuerung"]]
   [:div.flex.items-center.justify-center.gap-3.p-5
    [ui/button {:variant :primary
                :size 4
                :class "flex-auto"
                :on-click #(deframe/route-assoc! ::workflow {:id (gensym) :edit-mode :flow})}
     [:span.text-xl "Auftrag erstellen"]]
    [ui/button {:variant :primary
                :size 4
                :class "flex-auto"
                :on-click #(deframe/route-assoc! ::select-edit-workflow true)
                :disabled (empty? @(deframe/!route-get ::workflows))}
     [:span.text-xl "Auftrag ändern"]]]
   (when @(deframe/!route-get ::select-edit-workflow)
     (into [:div
            [:div.border-t.px-5.py-2.text-xs.font-bold.bg-slate-100 "Bestehende Aufträge"]]
           (map (fn [{:as workflow :keys [id]}]
                  [:div.border-t.py-2.px-5.text-base.flex.justify-between.items-center.hover:bg-indigo-50.last:rounded-b-lg.hover:cursor-pointer.hover:text-indigo-600
                   {:on-click #(edit-workflow! id)}
                   [:span.text-lg (:name workflow)]
                   [ui/button {:variant :primary
                               :size 4
                               :on-click #(edit-workflow! id)} "Bearbeiten"]]))
           (vals @(deframe/!route-get ::workflows))))])

(defn edit-service! [id])

(defn service-form []
  [:div.flex.items-center.justify-center
   [:div.bg-white.shadow-xl.border.rounded-lg.flex.flex-col.mb-8.w-full
    {:class "max-w-[650px]"}
    [:div.p-5.bg-slate-100.rounded-t-lg.border-b
     [:div.text-xl.font-bold "neue Dienstleistung"]]
    [:div.p-5.border-b.last:border-b-0
     [ui/with-label
      [:span.font-bold.text-lg.mb-2 "Dienstleistungsname"]
      [:input {:class "w-full text-lg border rounded-lg px-4 py-2 "
               :on-input #(deframe/route-assoc-in! [::state :service-name] (.. % -target -value))
               :value @(deframe/!route-get-in [::service :name])}]]]
    [:div.p-5.border-b.last:border-b-0
     [:span.font-bold.text-lg.mb-2 "verfügbar in"]
     [:div.flex.gap-5.mt-2
      [:div.flex.items-center.gap-2
       [:input {:type :checkbox :id ""}]
       [:label {:for ""} "Eingang"]]
      [:div.flex.items-center.gap-2
       [:input {:type :checkbox :id ""}]
       [:label {:for ""} "Lager"]]
      [:div.flex.items-center.gap-2
       [:input {:type :checkbox :id ""}]
       [:label {:for ""} "nach Lager"]]
      [:div.flex.items-center.gap-2
       [:input {:type :checkbox :id ""}]
       [:label {:for ""} "Ausgang"]]]]
    [:div.p-5.border-b.last:border-b-0
     [:span.font-bold.text-lg.mb-2 "Verfügbare Eigenschaften"]
     [:div.flex.flex-col.gap-2.mt-2
      [:div.px-3.py-2.rounded-md.border.bg-slate-50
       [:div.flex.items-center.gap-2
        [:input {:type :checkbox :id ""}]
        [:label.font-bold {:for ""} "numerisches Feld mit Name und Einheit"]]
       [:div.flex.items-center.gap-2.mt-1
        [:label "Name"]
        [ui/input {:placeholder "Name" :size 4}]
        [:label.ml-2 "Einheit"]
        [select
         {:class "py-2"}
         [:option "keine"]
         [:option "L"]
         [:option "%"]
         [:option "km"]
         [:option "kWh"]
         [:option "V"]]]]
      [:div.px-3.py-2.rounded-md.border.bg-slate-50
       [:div.flex.items-center.gap-2
        [:input {:type :checkbox :id ""}]
        [:label.font-bold {:for ""} "Liste mit "]
        [select
         {:class "py-2"}
         [:option "Einfachauswahl"]
         [:option "Mehrfachauswahl"]]]]
      [:div.px-3.py-2.rounded-md.border.bg-slate-50
       [:div.flex.items-center.gap-2
        [:input {:type :checkbox :id ""}]
        [:label.font-bold {:for ""} "Intervall möglich (nur für Lager)"]]]]]
    [:div.p-5.border-b.last:border-b-0
     [:span.font-bold.text-lg.mb-2 "MDE-Ansicht"]
     [:div.mt-2
      [select
       {:class "py-2"}
       [:option "automatisch"]
       [:option "Datum erfassen"]
       [:option "Tanken"]
       [:option "Parken"]
       [:option "FIN/ARS-ID verheiraten"]
       [:option "Hochvoltbatterieladestatus erfassen"]
       [:option "Zusatzinfos LKW Eingang"]]]]
    [:div.p-5
     (when-not @(deframe/!route-get-in [::workflow :name])
       [ui/button
        {:variant :primary
         :size 4
         :on-click #(deframe/route-assoc-in! [::service :name] @(deframe/!route-get-in [::state :service-name]))}
        [:span.text-xl "Neue Dienstleistung anlegen"]])]]])

(defn services-menu []
  [:div.bg-white.shadow-xl.border.rounded-lg.flex.flex-col.mb-8
   {:class "min-w-[650px]"}
   [:div.p-5.bg-slate-100.rounded-t-lg.border-b
    [:div.text-center.text-xl.font-bold "Dienstleistungsverwaltung"]]
   [:div.flex.items-center.justify-center.gap-3.p-5
    [ui/button {:variant :primary
                :size 4
                :class "flex-auto"
                :on-click #(deframe/route-assoc! ::service {:id (gensym)})}
     [:span.text-xl "Dienstleistung erstellen"]]
    [ui/button {:variant :primary
                :size 4
                :class "flex-auto"
                :on-click #(deframe/route-assoc! ::select-edit-service true)
                :disabled (empty? @(deframe/!route-get ::services))}
     [:span.text-xl "Dienstleistung ändern"]]]
   (when @(deframe/!route-get ::select-edit-workflow)
     (into [:div
            [:div.border-t.px-5.py-2.text-xs.font-bold.bg-slate-100 "Bestehende Dienstleistungen"]]
           (map (fn [{:as service :keys [id]}]
                  [:div.border-t.py-2.px-5.text-base.flex.justify-between.items-center.hover:bg-indigo-50.last:rounded-b-lg.hover:cursor-pointer.hover:text-indigo-600
                   {:on-click #(edit-service! id)}
                   [:span.text-lg (:service/code service)]
                   [ui/button {:variant :primary
                               :size 4
                               :on-click #(edit-service! id)} "Bearbeiten"]]))
           (vals @(deframe/!route-get ::services))))])

(defn render-edit-workflow [_result {:as match :keys [data]}]
  (let [workflow @(deframe/!route-get ::workflow)
        service @(deframe/!route-get ::service)]
    (cond
      workflow [:div.flex.items-center.justify-center
                [:div.bg-white.shadow-xl.border.rounded-lg.flex.flex-col.mb-8
                 {:class "min-w-[650px]"}
                 [:div.p-5.border-b.bg-slate-100.rounded-t-lg
                  [:div.text-xl.font-bold
                   (if @(deframe/!route-get-in [::workflow :editing?])
                     "Auftrag bearbeiten"
                     "Auftrag erstellen")]]
                 [:nav.border-b
                  [:ol.flex
                   [:li.flex-auto
                    [:button.px-5.py-4.border-t-4.w-full.flex.flex-col.group
                     {:on-click #(do (.preventDefault %)
                                     (deframe/route-assoc-in! [::workflow :edit-mode] :flow))
                      :class (if (= (:edit-mode workflow) :flow)
                               "border-t-indigo-600 hover:border-t-indigo-600"
                               "border-t-slate-200 hover:border-t-slate-300")}
                     [:span.text-sm.font-bold {:class (if (= (:edit-mode workflow) :flow)
                                                        "text-indigo-600 group-hover:text-indigo-600"
                                                        "text-slate-600 group-hover:text-indigo-600")} "Schritt 1"]
                     [:span.text-sm.font-medium "Auftrag"]]]
                   [:li.flex-auto
                    [:button.px-5.py-4.border-t-4.w-full.flex.flex-col.group
                     {:on-click #(do (.preventDefault %)
                                     (deframe/route-assoc-in! [::workflow :edit-mode] :pricing))
                      :class (if (= (:edit-mode workflow) :pricing)
                               "border-t-indigo-600 hover:border-t-indigo-600"
                               "border-t-slate-200 hover:border-t-slate-300")}
                     [:span.text-sm.font-bold {:class (if (= (:edit-mode workflow) :pricing)
                                                        "text-indigo-600 group-hover:text-indigo-600"
                                                        "text-slate-600 group-hover:text-indigo-600")} "Schritt 2"]
                     [:span {:class "text-sm font-medium"} "Preise"]]]]]
                 (case (:edit-mode workflow)
                   :flow [flow]
                   :pricing [pricing])]]
      service [service-form]
      :else [:div.flex.flex-col.gap-8.items-center.justify-center
             [workflow-menu]
             [services-menu]])))
